import { PackageProps } from "../../packages/store/actionType";

export enum actionTypes {
  //fetch membership duration
  FETCH_MEMBERSHIP_DURATION_REQUEST = "FETCH_MEMBERSHIP_DURATION_REQUEST",
  FETCH_MEMBERSHIP_DURATION_SUCCESS = "FETCH_MEMBERSHIP_DURATION_SUCCESS",
  FETCH_MEMBERSHIP_DURATION_FAIL = "FETCH_MEMBERSHIP_DURATION_FAIL",
  //create membership duration
  CREATE_MEMBERSHIP_DURATION_REQUEST = "CREATE_MEMBERSHIP_DURATION_REQUEST",
  CREATE_MEMBERSHIP_DURATION_SUCCESS = "CREATE_MEMBERSHIP_DURATION_SUCCESS",
  CREATE_MEMBERSHIP_DURATION_FAIL = "CREATE_MEMBERSHIP_DURATION_FAIL",
  //update membership duration
  UPDATE_MEMBERSHIP_DURATION_REQUEST = "UPDATE_MEMBERSHIP_DURATION_REQUEST",
  UPDATE_MEMBERSHIP_DURATION_SUCCESS = "UPDATE_MEMBERSHIP_DURATION_SUCCESS",
  UPDATE_MEMBERSHIP_DURATION_FAIL = "UPDATE_MEMBERSHIP_DURATION_FAIL",
  //delete membership duration
  DELETE_MEMBERSHIP_DURATION_REQUEST = "DELETE_MEMBERSHIP_DURATION_REQUEST",
  DELETE_MEMBERSHIP_DURATION_SUCCESS = "DELETE_MEMBERSHIP_DURATION_SUCCESS",
  DELETE_MEMBERSHIP_DURATION_FAIL = "DELETE_MEMBERSHIP_DURATION_FAIL",
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface MembershipDurationsProps {
  number_of_days: string;
  package_id: string;
  duration_type: string;
  created_at: string;
  description: string;
  price: string;
  id: string;
  updated_at: string;
  price_usd:string;
  package: PackageProps;
}
export interface CreateMembershipDurationInput {
  duration_type: string;
  price: string;
  number_of_days: string;
  description: string;
  package_id: string;
  price_usd:string;
}
export interface UpdateMembershipDurationInput {
  package_id: string;
  duration_id: string;
  duration_type: string;
  price: string;
  number_of_days: string;
  description: string;
  price_usd:string;
}
export interface CreateMembershipDurationError {
  duration_type?: string;
  price?: string;
  number_of_days?: string;
  description?: string;
  package_id?: string;
  price_usd?: string;
}

//fetch membership duration
export interface FetchMembershipDurationRequestAction {
  type: actionTypes.FETCH_MEMBERSHIP_DURATION_REQUEST;
}

export interface FetchMembershipDurationSuccessAction {
  type: actionTypes.FETCH_MEMBERSHIP_DURATION_SUCCESS;
  payload: MembershipDurationsProps[];
}

export interface FetchMembershipDurationFailAction {
  type: actionTypes.FETCH_MEMBERSHIP_DURATION_FAIL;
  payload: string;
}

//create membership duration
export interface CreateMembershipDurationRequestAction {
  type: actionTypes.CREATE_MEMBERSHIP_DURATION_REQUEST;
}

export interface CreateMembershipDurationSuccessAction {
  type: actionTypes.CREATE_MEMBERSHIP_DURATION_SUCCESS;
  payload: MembershipDurationsProps;
}

export interface CreateMembershipDurationFailAction {
  type: actionTypes.CREATE_MEMBERSHIP_DURATION_FAIL;
  payload: string;
}
//update membership duration
export interface UpdateMembershipDurationRequestAction {
  type: actionTypes.UPDATE_MEMBERSHIP_DURATION_REQUEST;
}

export interface UpdateMembershipDurationSuccessAction {
  type: actionTypes.UPDATE_MEMBERSHIP_DURATION_SUCCESS;
  payload: MembershipDurationsProps;
}

export interface UpdateMembershipDurationFailAction {
  type: actionTypes.UPDATE_MEMBERSHIP_DURATION_FAIL;
  payload: string;
}
//delete membership duration
export interface DeleteMembershipDurationRequestAction {
  type: actionTypes.DELETE_MEMBERSHIP_DURATION_REQUEST;
}

export interface DeleteMembershipDurationSuccessAction {
  type: actionTypes.DELETE_MEMBERSHIP_DURATION_SUCCESS;
  payload: string;
}

export interface DeleteMembershipDurationFailAction {
  type: actionTypes.DELETE_MEMBERSHIP_DURATION_FAIL;
  payload: string;
}
export type MembershipDurationActions =
  | FetchMembershipDurationRequestAction
  | FetchMembershipDurationSuccessAction
  | FetchMembershipDurationFailAction
  | CreateMembershipDurationRequestAction
  | CreateMembershipDurationSuccessAction
  | CreateMembershipDurationFailAction
  | UpdateMembershipDurationRequestAction
  | UpdateMembershipDurationSuccessAction
  | UpdateMembershipDurationFailAction
  | DeleteMembershipDurationRequestAction
  | DeleteMembershipDurationSuccessAction
  | DeleteMembershipDurationFailAction;
